import Aos from "aos";
import { useEffect } from "react";


export const TestimonialCard = ({ title, text, author, rating = 5, aosDelay }) => {
    return (
        <div className="testimonial-card" data-aos="fade-up" data-aos-delay={aosDelay}>
            <div className="card-stars">
                {Array.from({ length: rating }).map((_, index) => (
                    <img
                        key={index}
                        src={`${process.env.PUBLIC_URL}/assets/icons/star.svg`}
                        className="star-icon"
                        alt="Star Rating"
                    />
                ))}
            </div>
            <h3>{title}</h3>
            <p>{text}</p>
            <div className="card-author">{author}</div>
        </div>
    );
};

const SolarFinancingTestimonials = () => {
    useEffect(() => {
        Aos.init({
            duration: 1000,
        });
    }, []);

    const testimonialsData = [
        {
            title: "Goodbye Generator, Hello Convenience!",
            text: "Thank you Checkoff for helping out, the convenience is so massive for my business, I never knew people are enjoying this way o, I packed my generator for two weeks now, this is overwhelming, thank you guys.",
            author: "John",
            aosDelay: "300"
        },
        {
            title: "Loan Approval Brings Timely Relief",
            text: "I wanted to sell my car to finance installation of solar for my business, but when I heard about this solar financing, I was so happy, it helped saved my business",
            author: "Esther",
            aosDelay: "450"
        },
        {
            title: "Efficient and Professional Team!",
            text: "Receiving financing from Checkoff Finance was a great experience. Their process was efficient, transparent, and customer-friendly. The funds came right on time and helped me achieve my goals without delay.",
            author: "Ayo",
            aosDelay: "600"
        }
    ];

    return (
        <section className="testimonials-section" data-aos="fade-up" data-aos-duration="1000">
            <div className="testimonial-badge" data-aos="fade-down" data-aos-delay="100">
                <img
                    src={`${process.env.PUBLIC_URL}/assets/icons/sun.svg`}
                    className="sun-icon"
                    alt="Sun Testimonial"
                />
                <span>Testimonial</span>
            </div>

            <h2 className="testimonials-heading" data-aos="fade-down" data-aos-delay="200">
                Happy Customers,<br />Happy World
            </h2>

            <div className="testimonials-grid">
                {testimonialsData.map((card, index) => (
                    <TestimonialCard
                        key={index}
                        title={card.title}
                        text={card.text}
                        author={card.author}
                        aosDelay={card.aosDelay}
                        rating={5}
                    />
                ))}
            </div>
        </section>
    )
}

export default SolarFinancingTestimonials